module.exports = __webpack_public_path__ + "static/privacy-65a0ec5733405315835755500684e812.jpeg";